export interface Mask {
  Mask: string;
  Prefix: string;
  Suffix: string;
}

export interface ValidCountry {
  CountryCode: string;
  StateCodes?: string;
}

export class Identificationtype {
  BackImage: boolean = false;
  FrontImage: boolean = false;
  IsTaxId: boolean = false;
  ForBeneficiary: boolean = false;
  ForCustomer: boolean = false;
  IssuerConCode: any = '';
  IssuerStateCode: any = '';
  Masks: Mask[];
  RequiresExpirationDate: boolean;
  TypeName: string = '';
  ValidCountries: ValidCountry[];
  DocumentNumber: string = '';
  DocumentID = 0;
  DocumentType: string = '';
  ExpirationDate: string = '';
  IsApproved: boolean = false;
  IssuedBy: string = '';
  UploadType: string = '';
  ImageType: string = '';
  ImageData: string = '';
  Names: any[];
  FrontImageUrl: string = '';
  BackImageUrl: string = '';
}

export interface RootObject {
  Identificationtypes: Identificationtype[];
}

// export class documentdetail {

// }



// WEBPACK FOOTER //
// ./src/app/models/User/documentupload/user.documentupload.model.ts